import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";

export class InventoryThresholdOverrideAlternative extends BaseBus
{
    constructor(data: InventoryThresholdOverrideAlternative) {
        super(data);
    }

    CID(): any {
        return this.inventoryAlternativeId;
    }

    initialize(data: InventoryThresholdOverrideAlternative) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
    }

    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }

    setFromForm(data: InventoryThresholdOverrideAlternative) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }
    }

    changeInventoryItem(data: v_InventoryBus) {
        this.inventoryAlternativeId = CommonFunctions.getGuid();
        this.alternateInventoryId = data.inventoryId;
        this.number = data.number;
        this.summary = data.inventoryDesc;
    }

    setId(id: any) {
        this.inventoryAlternativeId = id;
    }

    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
    }

    setCommon(userId: any, date: Date, companyId: any = null) {
            this.insertDt = date;
            this.insertUserId = userId;
    }

    inventoryAlternativeId: string;
    primaryInventoryId: string;
    alternateInventoryId: string;
    number: string;
    summary: string;
    specifications: string;
    supplierPartNumbers: string;
    insertDt: Date;
    insertUserId: string;
    deleted: boolean;

    get canEdit(): boolean {
        let can: boolean = true;

        return can;
    }
}
